var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meeting-topics_wrapper"},[_c('div',{staticClass:"ql-editor ql-blank"},[_c('div',{staticClass:"ql-container",domProps:{"innerHTML":_vm._s(_vm.value)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }